import React from 'react';
import { Box, Typography } from '@mui/material';

const ChevronSeparator = () => (
  <svg className="breadcrumb-nav__separator" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const HomeIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 9.5 12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V9.5z" />
  </svg>
);

const BreadcrumbPreview: React.FC = () => (
  <Box sx={{ mt: 1.5, mb: 1, pl: 4 }}>
    <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
      Mağazada görünüm — yalnızca path:
    </Typography>

    <div className="breadcrumb-nav breadcrumb-nav--inline" style={{ '--breadcrumb-accent': '#f27a1a' } as React.CSSProperties}>
      <div className="breadcrumb-nav__inner">
        <nav aria-label="Breadcrumb önizleme">
          <ol className="breadcrumb-nav__track">
            <li className="breadcrumb-nav__item">
              <a href="#" className="breadcrumb-nav__link" onClick={(e) => e.preventDefault()}>
                <HomeIcon />
                <span>Ana Sayfa</span>
              </a>
            </li>
            <li className="breadcrumb-nav__item">
              <ChevronSeparator />
              <a href="#" className="breadcrumb-nav__link" onClick={(e) => e.preventDefault()}>
                Kadın
              </a>
            </li>
            <li className="breadcrumb-nav__item">
              <ChevronSeparator />
              <span className="breadcrumb-nav__current">Güneş Kremleri</span>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
      Kategori sayfasında büyük başlık gösterilmez; yalnızca breadcrumb path görünür.
    </Typography>
  </Box>
);

export default BreadcrumbPreview;
